module.exports = __webpack_public_path__ + "static/media/Create_discount_codes2.90d08b70.svg";